import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/shared/postActionBar.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { API_BASE_URL } from './config/api';
import { installAuthTransport } from './utils/authToken';

// Must run before any API request so every call carries the login token.
installAuthTransport();

if (!/maintenance\.html$/i.test(window.location.pathname)) {
  fetch(`${API_BASE_URL}/maintenance_status.php`, { cache: 'no-store' })
    .then((res) => res.json())
    .then((data) => {
      if (data && data.maintenance) {
        window.location.replace(`${process.env.PUBLIC_URL || ''}/maintenance.html`);
      }
    })
    .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="135048520941-d21ot41o25qha09hgrdmef9njkki4n82.apps.googleusercontent.com">
    
   <App /> {/* 🚫 App should NOT have another BrowserRouter inside */}
  
    </GoogleOAuthProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
